import axios from 'axios'
import Cookies from "js-cookie";
import urlApis from '../Api.config'
import Api from "./config/api/axios.urlcontext"


/**
 *Proporciona los servicios para manejar el registro y el acceso a los tramites de planeacion
 * @author Amairani de los Ángeles Barsanas Hernández
 */


export default class AutorizacionTramiteshacienda{
    constructor(){}
    /**
     * Obtiene los datos de los empleados mediante el numero de empleado y el rfc
     * @returns datos del empleado
     */
     async GetDatosEmpleado(rfc, numEmpleado)
    {
      // console.log('GetDatosEmpleado');
        const url = Api.APP_URL_API_EVOLUCION+':8083/EmpleadosApi/Persona/BuscaRFCURP/';
        let target = axios.get(url+rfc+"/"+numEmpleado).then(
            function (res)
            {
                let success = res.status==200? true : false;

                if(success){
                    let obj = { "success": success, "data": res.data, "error": '' }
                    return obj;
                }

            }).catch((error) =>{
                let obj = { "success": false, "data": '', "error": error }
                return obj;
            });
        return target;
    }


    /**
     * Obtiene Token de autenticacion para utilizar los servicios
     * @returns token
     */
    async GetTokenServer()
    {
        const data ={parametro: "funcionariox", password: "123456", apiKey: "B6B08AF9-7917-4882-80F0-16222E792944"}
        let target = urlApis.apiAuth().post('/Acceder', data).then(
            function (res)
            {
                let success = res.status==200? true : false;

                if(success){
                    let obj = { "success": success, "data": res.data.token, "error": '' }
                    return obj;
                }
            }).catch((error) =>{
                let obj = { "success": false, "data": '', "error": error }
                return obj;
            });
        return target;

    }
    /**
     * Obtiene Token de autenticacion para utilizar los servicios desde archivo php
     * @returns token
     */
     async GetTokenServer2()
     {
         let target = urlApis.serverAuthTramitesHacienda().post().then(
             function (res)
             {
                 // console.log(res);
                 let success = res.status==200? true : false;

                 let obj = { "success": success, "data": res.data, "error": '' }
                 return obj;

             }).catch((error) =>{
                 let obj = { "success": false, "data": '', "error": error }
                 return obj;
             });
         return target;
     }
    /**
     * Inserta un nuevo usuario aun no activado y manda un correo con un codigo de activación
     * @returns Datos del usuario no activado registrado
     */
    async consultaRegistro_sinActivacion(token, object_body){
        // let config_Serve = {
        //     url: 'http://200.57.183.184:8082/key/api/Auth/Registrar_sinactivacion',
        //     headers: {
        //         'Authorization' : 'Bearer' + ' ' + token,
        //         'Content-Type': 'application/json'
        //     },
        //     data : object_body
        // };
        const url =  Api.APP_URL_API_EVOLUCION+':8083/key/api/Auth/Registrar_sinactivacion'
        let config_Serve = {
            headers: {
                'Authorization' : token,
             'Content-Type': 'application/json'
            },
            data : object_body
     };
        let target = axios.post(url, config_Serve).then(
            function (res)
       {
           return res;
       }).catch((error) =>{
           return error;
       });
   return target;
    }



    /**
    * Login de usuario para tramites
    * @returns puede retornar = "credenciales invalidas", o: idstatus 0:inactivo,  1=activado
    */
    async LoginUser(user, pass)
    {
        const token_vencido = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJZFVzdWFyaW8iOiIxMTQ5IiwiR3VpZF91c3VhcmlvIjoiMWViY2JhY2UtNGVkNS00ODY0LTlmNGItZDcwM2Q0NTMwZGUzIiwiTG9naW4iOiJmdW5jaW9uYXJpb3giLCJDb3JyZW9fZWxlY3Ryb25pY28iOiJpc2NqdWFudG9sZWRvQGdtYWlsLmNvbSIsIk5vbWJyZV9wYW50YWxsYSI6ImZ1bmNpb25hcmlvIHBydWViYSIsIkN1cnAiOiJBRUxPNjkxMDEzSENTUlJTMDgiLCJleHAiOjE2MjgwOTkxNDcsImlzcyI6ImludGVyb3BlcmEuaGFjaWVuZGFjaGlhcGFzLmdvYi5teCIsImF1ZCI6ImludGVyb3BlcmEuaGFjaWVuZGFjaGlhcGFzLmdvYi5teCJ9.dQl9C5SOY6ob_JQNUkT4rE_5lUimtaAfPF4YIVwuXv8";
        let obj = null;
        let data = { "parametro": user, "password": pass, "apiKey": "B6B08AF9-7917-4882-80F0-16222E792944" }
        let target = urlApis.apiAuth().post('/Acceder', data).then(
            function (res)
            {
                let success = res.status==200? true : false;
                obj = { "success": success, "data": res.data, "error": '' }
                // axios.defaults.headers.common['Authorization'] = `Bearer ${res.data.token}`;
                urlApis.apiAuth().defaults.headers["Authorization"]= `Bearer ${res.data.token}`;
                //urlApis.apiAuth().defaults.headers["Authorization"]= `Bearer ${token_vencido}`;
                return obj;

            }).catch((error) =>{
                //console.log('asdasd');
                console.log(error);
                // console.log(error.response.status);
                if(error.response.status == 400){
                    return obj = { "success": false, "data": '', "error": 400 } // error 400 es de credenciales invalidas

                }else{
                    console.log(error.response.status);
                    return obj = { "success": false, "data": '', "error": error.response.status }
                }


            });
        return target;
    }

     /**
     * verificacion de token, si esta vencido o no
     * @returns true o false
     */
      async VerificacionToken(token)
      {
        // este token vencido es para hacer pruebas 😸😀😝
        const token_vencido = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJZFVzdWFyaW8iOiIxMTQ5IiwiR3VpZF91c3VhcmlvIjoiMWViY2JhY2UtNGVkNS00ODY0LTlmNGItZDcwM2Q0NTMwZGUzIiwiTG9naW4iOiJmdW5jaW9uYXJpb3giLCJDb3JyZW9fZWxlY3Ryb25pY28iOiJpc2NqdWFudG9sZWRvQGdtYWlsLmNvbSIsIk5vbWJyZV9wYW50YWxsYSI6ImZ1bmNpb25hcmlvIHBydWViYSIsIkN1cnAiOiJBRUxPNjkxMDEzSENTUlJTMDgiLCJleHAiOjE2MjgwOTkxNDcsImlzcyI6ImludGVyb3BlcmEuaGFjaWVuZGFjaGlhcGFzLmdvYi5teCIsImF1ZCI6ImludGVyb3BlcmEuaGFjaWVuZGFjaGlhcGFzLmdvYi5teCJ9.dQl9C5SOY6ob_JQNUkT4rE_5lUimtaAfPF4YIVwuXv8";

          let target = urlApis.apiAuth().post('/ValidarToken?Token='+token).then(
              function (res)
              {
                  let success = res.status==200? true : false;

                  if(success){
                      let obj = { "success": success, "data": res.data, "error": '' }
                      return obj;
                  }
              }).catch((error) =>{
                  let obj = { "success": false, "data": '', "error": error }
                  return obj;
              });
          return target;

      }

   /**
     * Guarda en la cookiee el nombre de usuario
     * @returns Usuario
     */
    setDatosCookie(idusuario, userName, token_auth){
        Cookies.set("idUsuario", idusuario);
        // Cookies.set("usuario", usuario);
        Cookies.set("userName", userName);
        Cookies.set("token_auth", token_auth);
    }

    // refresh token
    setTokenAuth(token_auth){
        Cookies.set("token_auth", token_auth);
    }

}

